<template>
  <div>
    <section class="info accordion">
      <div class="px-4">
        <table class="noselect w-100 table table-hover bg-white">
          <template v-for="(stats, client_id) in statsClient">
            <tbody
              :key="client_id + 2"
              :id="'collapseLocation' + client_id"
              class=""
              :aria-labelledby="'collapseLocation' + client_id"
              data-parent="#accordionlocation"
            >
              <tr
                :key="client_id + 'header'"
                class="font-weight-bold"
                v-if="statsDate.length > 0"
              >
                <td width="160px"></td>
                <td
                  width="120px"
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <b>{{ date.date }}</b>
                </td>
                <td class="text-right" v-if="statsDate.length > 1 && showTotal == true">Total</td>
              </tr>
              <template v-if="!onlyTotal">
                <tr
                  v-for="statItem in statsType"
                  :key="statItem.id"
                  :set="(type = statItem.id)"
                  :class="statItem.className"
                >
                  <td v-if="!tooltip">
                    <b>{{ statItem.label }}</b>
                  </td>
                  <td v-else-if="statItem.tooltip">
                    <Tooltip :text="statItem.tooltip" :width="'auto'">
                      <b>{{ statItem.label }}</b>
                    </Tooltip>
                  </td>
                  <td v-else>
                    <b>{{ statItem.label }}</b>
                  </td>

                  <td
                    v-for="date in statsDate"
                    :key="client_id + type + date.date"
                    class="text-right"
                    :class="{ 'stats-table-cell-nowrap': compactCells }"
                  >
                    <span
                    :class="formatColor( stats[date.date][type + '_' + statItem.format], statItem, stats[date.date]['availableHours'])"
                      v-if="
                        stats[date.date] != undefined &&
                        stats[date.date][type + '_' + statItem.format] !=
                          undefined
                      "
                    >
                      <span
                        class="small mr-1"
                        v-if="
                          statItem.showQty &&
                          stats[date.date] != undefined &&
                          stats[date.date][type] != undefined
                        "
                        >({{ stats[date.date][type] }})</span
                      >

                      <span v-if="setObjetive && stats[date.date][type + '_' + statItem.format]" :class="colorConsistency(stats[date.date][type + '_' + statItem.format])">
                        {{
                          formatItemConsistency(
                            stats[date.date][type + "_" + statItem.format],
                            statItem
                          )                       
                        }}
                      </span>

                      <span v-else>
                      {{
                        formatItem(
                          stats[date.date][type + "_" + statItem.format],
                          statItem
                        )
                       
                      }}
                      </span>
                      
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td
                    class="text-right font-weight-bold"
                    :class="{ 'stats-table-cell-nowrap': compactCells }"
                    v-if="statsDate.length > 1"
                  >
                    <span v-if="statItem.showTotal && !setObjetive">
                      <span class="small" v-if="statItem.showQty && stats[type]"
                        >({{ stats[type] }})</span
                      >
                      {{
                        formatItem(
                          stats[type + "_" + statItem.format],
                          statItem
                        )
                      }}
                    </span>
                    <span v-if="statItem.showTotal && setObjetive">                      
                      {{
                          formatItemConsistencyTotal(
                          stats[type + "_" + statItem.format],
                          statItem
                        )
                      }}
                    </span>
                  </td>
                </tr>
              </template>
              <tr
                class="font-weight-bold"
                v-if="statsDate.length > 1 && showTotal"
              >
                <td>{{ setObjetive ? "Objetive" : "Total"}}</td>

                <td
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                  :class="{ 'stats-table-cell-nowrap': compactCells }"
                >
                  <span v-if="getTotal(date.date, stats)">
                    <span
                      class="small"
                      v-if="!onlyTotal && getTotalQty(date.date, stats)"
                      >({{ getTotalQty(date.date, stats) }})</span
                    >
                    {{ getTotal(date.date, stats) }}
                  </span>
                </td>
                <td class="text-right" :class="{ 'stats-table-cell-nowrap': compactCells }">
                  <span>
                    <span class="small" v-if="!onlyTotal && showQty"
                      >({{ getFullTotalQty(stats) }})</span
                    >
                    {{ getFullTotal(stats) }}
                  </span>
                </td>
              </tr>
              <tr
                class="font-weight-bold"
                v-if="setObjetive"
              >
                <td>Consistency</td>

                <td
                  v-for="date in statsDate"
                  :key="client_id + date.date"
                  class="text-right"
                >
                  <span v-if="getTotal(date.date, stats)">
                    <span
                      class="small"
                      v-if="!onlyTotal && getTotalQty(date.date, stats)"
                      >({{ getTotalQty(date.date, stats) }})</span
                    >
                    {{ getTotal(date.date, stats, true) }}
                  </span>
                </td>  
                <td class="text-right">
                  <span>
                    <span class="small" v-if="!onlyTotal && showQty"
                      >({{ getFullTotalQty(stats) }})</span
                    >
                    {{ getFullTotal(stats, true) }}
                  </span>
                </td>    
              </tr>
            </tbody>
          </template>
        </table>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  props: {
    tooltip: {
      type: Boolean,
      default: false,
    },
    // stats: {
    //   type: Object,
    //   required: true,
    // },
    daysNonWorking: {
      type: Array,
      default: () => [],
    },
    filterMonth: {
      type: String,
      default: "",
    },
    setObjetive: {
      type: Boolean,
      default: false,
    },
    statsClient: {
      type: Object,
      required: true,
    },
    statsType: {
      type: Array,
      required: true,
    },
    statsDateTotal: {
      type: Number,
      default: 0,
    },
    statsDate: {
      type: Array,
      required: true,
    },
    onlyTotal: {
      type: Boolean,
      onlyTotal: false,
    },
    showTotal: {
      type: Boolean,
      onlyTotal: true,
    },
    showQty: {
      type: Boolean,
      onlyTotal: true,
    },
    currentDateHour: {
      type: String,
      default: "",
    },
    /** Cuando true, evita que el contenido (p. ej. porcentaje + número) haga salto de línea en celdas con muchas columnas */
    compactCells: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      totalByDay: [],
      successFull: false,
      totalItemsFull: false,
    };
  },  
  components: {
    LoadingSpinner,
    Tooltip,
  },
  methods: {
    formatColor(amount, statItem, hoursAvailable) {            
                  
      // Si no hay valor o no se debe aplicar color, retornar vacío     
      if (isNaN(amount)) {
          return ""
        }
      
      // Verificar si tenemos las horas disponibles y la hora actual esta incluida en las horas a validar
      const hour = Number(statItem.label.substring(0, 2))           
      
      if (!hoursAvailable || !hoursAvailable.includes(hour)) {
        return "";
      } 

      if(amount < 12 ){
        return "text-white bg-danger px-2 rounded";
      } else {
        return "text-black bg-success px-2 rounded";
      }              
    },
    formatItemConsistency(data, statItem) {
      return data.label
    },
    formatItemConsistencyTotal(data, statItem) {
      const filtered = Object.values(this.statsClient[0])
        .map(item => Object.values(item))    
        .flat()                              
        .filter(sub => sub.name == statItem.label);            
      const totalTasksVerified = filtered.reduce((acc, value) => acc + value.total_verified_tasks, 0);
      const totalCalls = filtered.reduce((acc, value) => acc + value.total_conversation_calls, 0);      
      return totalTasksVerified + ' / ' + totalCalls
    },
    colorConsistency(data){
      return (data.status == 'yes') ? 'bg-success px-2 rounded' :  'bg-danger px-2 rounded'
    },

    formatItem(amount, statItem) {
      if (statItem.format === "text") {
        if (amount == null || amount === undefined || amount === "") {
          return "-";
        }
        return String(amount);
      }
      if (amount == null || amount === undefined || isNaN(amount)) {
        return "-";
      }
      switch (statItem.format) {
        case "amount":
          return parseFloat(amount).toFixed(2) + " €";
        case "percentage":
          return parseFloat(amount).toFixed(2) + " %";
        case "qty":
          return parseFloat(amount).toFixed(0);
        case "avg":
        case "rate":
          return parseFloat(amount).toFixed(2) + ' %';
      }
    },
    getTotal(date, stats, consistency = false) {
      let existData = false;
      let total = 0;
      let count = 0;
      let success = 0;
      let total_items = 0;
      let format = null;
      this.statsType.forEach((statItem) => {
        format = statItem.format;
        let type = statItem.id;

        if(this.setObjetive){          
          // Verificar si tenemos las horas disponibles y la hora actual esta incluida en las horas a validar
          const hour = Number(statItem.label.substring(0, 2))           
            
          const hoursAvailable = stats[date]["availableHours"]

          if (!hoursAvailable || !hoursAvailable.includes(hour)) {
            return "";
          } 
          
          const itemComplete = stats[date][type + "_" + statItem.format]

          success += (itemComplete && itemComplete.status && itemComplete.status == 'yes' && hoursAvailable && hoursAvailable.includes(hour)) ? 1 : 0               
          
          const currentDay = moment(this.currentDateHour, "YYYY-MM-DD HH:mm:ss").format("DD");
          const currentMonth = moment(this.currentDateHour, "YYYY-MM-DD HH:mm:ss").format("MM");
          const currentHour = moment(this.currentDateHour, "YYYY-MM-DD HH:mm:ss").format("HH");

          const isHourAvailable = (date == Number(currentDay) && Number(hour)  <= Number(currentHour)) ? true : false
          const today = moment(this.filterMonth + '-'+ date).format("YYYY-MM-DD");
          const monthSelected = moment(this.filterMonth, "YYYY-MM").format("MM");
//          total_items +=  (((hoursAvailable || hoursAvailable.includes(hour) ) && !this.daysNonWorking.includes(today) && date != Number(currentDay)) || (date == Number(currentDay)  && isHourAvailable) )  ? 1 : 0
          total_items +=  (((hoursAvailable || hoursAvailable.includes(hour) ) && !this.daysNonWorking.includes(today) && ( date != Number(currentDay) || monthSelected != currentMonth) ) || date == Number(currentDay)  && isHourAvailable)   ? 1 : 0
          count++;
          existData = true;

          // Actualizar valores globales solo si es necesario          
          const index = this.totalByDay.findIndex((item) => item.day === date);
          const day = { day:date, success: success, total_items: total_items };

          if(index !== -1){
            this.totalByDay[index].success = success;
            this.totalByDay[index].total_items = total_items;
          } else {
            this.totalByDay.push(day);                            
          }            
          

        } else {
          if (stats[date][type + "_" + statItem.format] != undefined) {
            total += parseFloat(stats[date][type + "_" + statItem.format]);
          }
          
          count++;
          existData = true;
          }      
      });

      if (existData) {
        if (["percentage", "rate"].includes(format)) {
          let symbol = format == "percentage" ? "%" : "";
          if (count > 0) {
            return parseFloat(total / count).toFixed(2) + " " + symbol;
          }
          return "";
        } else {
          if (format == "qty") {
            if(this.setObjetive){
              if(consistency){

                const today = moment(this.filterMonth + '-'+ date).format("YYYY-MM-DD");

                return !this.daysNonWorking.includes(today)  ? ((success / total_items) * 100).toFixed(0) + ' %' : '-';                
              } else {
                
                const today = moment(this.filterMonth + '-'+ date).format("YYYY-MM-DD");

                return  !this.daysNonWorking.includes(today)  ? `${success} / ${total_items}` : '-';
              }              
            } else {
              return parseFloat(total).toFixed(2);
            }
            
          }
          if (isNaN(total)) {
            return "-";
          }
          return parseFloat(total).toFixed(2);
        }
      }
      return false;
    },
    getTotalQty(date, stats) {
      let existData = false;
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[date][type] != undefined) {
          total += parseFloat(stats[date][type]);
          existData = true;
        }
      });
      if (existData) {
        return parseFloat(total).toFixed(0);
      } else {
        return false;
      }
    },
    getFullTotal(stats, consistency = false) {

      //Si es opocion Consistency
      if (this.setObjetive) {
          
          let success = 0;
          let total_items = 0;
          
          if (this.successFull && this.totalItemsFull) {               
            return !consistency ? `${this.successFull} / ${this.totalItemsFull}` : ((this.successFull / this.totalItemsFull) * 100).toFixed(0) + ' %' 
          } else {
            if(this.totalByDay.length > 0){              
              this.totalByDay.forEach((day) => {
              success += day.success;
              total_items += day.total_items;
              });
            }
            this.successFull = success;
            this.totalItemsFull = total_items;
            return !consistency ? `${success} / ${total_items}` : ((success / total_items) * 100).toFixed(0) + ' %' 
          }        
      }

      let total;
      let format = "";
      this.statsType.forEach((statItem) => {
        total = total == undefined ? 0 : total;
        let type = statItem.id;
        format = statItem.format;
        if (stats[type + "_" + statItem.format] != undefined) {
          total += parseFloat(stats[type + "_" + statItem.format]);
        }
      });

      if (format == "qty") {
        total = parseFloat(total).toFixed(0);
      }

      if (isNaN(total)) {
        return "-";
      }
      return parseFloat(total).toFixed(2);
    },
    getFullTotalQty(stats) {
      let total = 0;
      this.statsType.forEach((statItem) => {
        let type = statItem.id;
        if (stats[type] != undefined) {
          total += parseFloat(stats[type]);
        }
      });
      return parseFloat(total).toFixed(0);
    },
  },
};
</script>
<style scoped>
.stats-table-cell-nowrap {
  white-space: nowrap;
}
</style>